import * as React from "react"
import FAQ from "./FAQ"
import MarketingPlans from "./MarketingPlans"
import PlanInfo from "./PlanInfo"
import OrganizationPlan from "./OrganizationPlan"
import CoachTestimonials from "./CoachTestimonials"
import { useLocation } from "react-router-dom"
import MoneyBackGuarantee from "./MoneyBackGuarantee"

const PricingPage: React.FC = () => {
  const location = useLocation()

  React.useEffect(() => {
    if (location.hash === "#faq") {
      window.scrollTo({
        top: 650,
        left: 0,
      })
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
      })
    }
  }, [location.hash])

  return (
    <div className="relative">
      <div className="-mt-40 bg-grayMist w-full h-[635px] sm:h-[400px] absolute top-0 left-0 z-0"></div>
      <div className="h-[100%] relative z-10 mx-auto sm:mt-[88px] max-w-screen-2xl overflow-hidden flex-col flex justify-center ">
        <section className="h-[214px] px-6 pt-8 sm:flex justify-between items-center md:px-48 mb-[235px] sm:mb-0">
          <div className="text-black font-['Beausite Classic'] leading-tight md:text-[36px] text-[28px]">
            <p className="font-bold">Powered by Coaches.</p>
            <p className="text-blurple font-bold">Built for Impact.</p>
            <p className="text-base text-slate-800 mt-1 mb-4">
              The coaching platform built to scale with your mission.
            </p>
          </div>
          <div className="flex items-center justify-center sm:ml-8">
            <iframe
              width="320"
              height="180"
              src="https://www.youtube.com/embed/LNlF9xn5e_0?si=gVoYT9PIpPkUiVUs&start=1"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="rounded-xl shadow-lg"
            ></iframe>
          </div>
        </section>

        <section className="mb-4 ">
          <div className="px-4">
            <MarketingPlans />
          </div>
        </section>

        <section className="h-full flex justify-center items-center">
          <div className="w-full max-w-[1060px] mx-auto flex justify-center items-center p-4 ">
            <OrganizationPlan />
          </div>
        </section>
        <PlanInfo />
        <MoneyBackGuarantee />

        <section className="w-full px-6 sm:px-12 py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="mb-6 text-center lg:text-left">
                <span className="inline-block bg-blurple text-white text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-2">
                  Got questions?
                </span>
                <h3 className="text-[28px] sm:text-[32px] font-bold font-['Beausite Classic'] text-black leading-tight">
                  Answers, straight from the source
                </h3>
              </div>

              <FAQ />

              <p className="mt-6 text-sm text-slate-700 text-center lg:text-center">
                Still stuck?{" "}
                <a
                  href="https://intercom.help/zoee/en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  Visit our help center
                </a>{" "}
                or email{" "}
                <a href="mailto:hello@zoee.com" className="underline">
                  hello@zoee.com
                </a>
                .
              </p>
            </div>

            <div>
              <div className="mb-6 text-center lg:text-left">
                <span className="inline-block bg-blurple/10 text-blurple text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-2">
                  Coach approved
                </span>
                <h3 className="text-[28px] sm:text-[32px] font-bold font-['Beausite Classic'] text-black leading-tight italic">
                  What real coaches are saying
                </h3>
              </div>

              <CoachTestimonials />
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default PricingPage
